import { defineMessages } from 'react-intl';

/** The copy of the Plan tab of a release (Releases v2, designs f1, f2, f3). */
export const planMessages = defineMessages({
  // f1 Rollout panel
  rolloutTitle: { id: 'app.sml.releases.plan.rollout.title', defaultMessage: 'Rollout' },
  rolloutCounts: {
    id: 'app.sml.releases.plan.rollout.counts',
    defaultMessage:
      '{posted} posted · {scheduled} scheduled · {drafts, plural, one {# draft} other {# drafts}} · {gaps, plural, one {# gap} other {# gaps}}',
  },
  today: { id: 'app.sml.releases.plan.today', defaultMessage: 'Today' },
  dayZero: { id: 'app.sml.releases.plan.day.zero', defaultMessage: 'Day 0' },
  addADraft: { id: 'app.sml.releases.plan.addADraft', defaultMessage: 'Add a draft' },
  taskLine: {
    id: 'app.sml.releases.plan.taskLine',
    defaultMessage: 'Add the Canvas in Spotify for Artists, then mark it in the plan.',
  },
  gapTitle: {
    id: 'app.sml.releases.plan.gap.title',
    defaultMessage: '{count, plural, one {# day has no post} other {# days have no post}}',
  },
  gapDays: { id: 'app.sml.releases.plan.gap.days', defaultMessage: '{days}.' },
  gapUsesAssets: {
    id: 'app.sml.releases.plan.gap.usesAssets',
    defaultMessage: 'The drafts use assets you have.',
  },
  gapMakes: {
    id: 'app.sml.releases.plan.gap.makes',
    defaultMessage:
      '{assets} {count, plural, one {is} other {are}} not made yet, so we add {count, plural, one {it} other {them}} as a Studio job ({credits, plural, =0 {free} one {# video credit} other {# video credits}}).',
  },
  gapReel: {
    id: 'app.sml.releases.plan.gap.reel',
    defaultMessage: 'An AI reel is made in the Studio. Make it there first.',
  },
  addDrafts: {
    id: 'app.sml.releases.plan.addDrafts',
    defaultMessage: '{count, plural, one {Add # draft} other {Add # drafts}}',
  },
  openStudioReel: { id: 'app.sml.releases.plan.openStudioReel', defaultMessage: 'Make an AI reel' },
  // Legend
  legendPosted: { id: 'app.sml.releases.plan.legend.posted', defaultMessage: 'Posted' },
  legendScheduled: { id: 'app.sml.releases.plan.legend.scheduled', defaultMessage: 'Scheduled' },
  legendDraft: { id: 'app.sml.releases.plan.legend.draft', defaultMessage: 'Draft' },
  legendGap: { id: 'app.sml.releases.plan.legend.gap', defaultMessage: 'Gap' },
  legendNote: {
    id: 'app.sml.releases.plan.legend.note',
    defaultMessage: 'A draft does not go out. Open it in the Composer to schedule it.',
  },
  // Post states
  statePosted: { id: 'app.sml.releases.plan.state.posted', defaultMessage: 'Posted' },
  stateScheduled: { id: 'app.sml.releases.plan.state.scheduled', defaultMessage: 'Scheduled' },
  stateDraft: { id: 'app.sml.releases.plan.state.draft', defaultMessage: 'Draft' },
  stateNeedsYou: { id: 'app.sml.releases.plan.state.needsYou', defaultMessage: 'Needs you' },
  stateFailed: { id: 'app.sml.releases.plan.state.failed', defaultMessage: 'Failed' },
  statePublishing: { id: 'app.sml.releases.plan.state.publishing', defaultMessage: 'Publishing' },
  // Add result (next to the button)
  resultCreated: {
    id: 'app.sml.releases.plan.result.created',
    defaultMessage: '{count, plural, one {# draft is on your calendar.} other {# drafts are on your calendar.}}',
  },
  resultQueued: {
    id: 'app.sml.releases.plan.result.queued',
    defaultMessage:
      '{count, plural, one {# asset is being made.} other {# assets are being made.}} Add the draft again when it is ready.',
  },
  resultNothing: {
    id: 'app.sml.releases.plan.result.nothing',
    defaultMessage: 'Nothing new to add. These days have their drafts.',
  },
  resultMissing: {
    id: 'app.sml.releases.plan.result.missing',
    defaultMessage: 'Not added: {days}. Make the asset in the Studio first.',
  },
  // f2 push
  pushTitle: { id: 'app.sml.releases.plan.pushPlan.title', defaultMessage: 'Push this song' },
  pushSubtitle: {
    id: 'app.sml.releases.plan.pushPlan.subtitle',
    defaultMessage: 'One post a week keeps an older song in the feed',
  },
  pushWeek: { id: 'app.sml.releases.plan.pushPlan.week', defaultMessage: 'Week {week}' },
  pushWeekToggle: { id: 'app.sml.releases.plan.pushPlan.weekToggle', defaultMessage: 'Add week {week}' },
  pushGapTitle: {
    id: 'app.sml.releases.plan.pushPlan.gapTitle',
    defaultMessage: '{count, plural, one {# week has no post} other {# weeks have no post}}',
  },
  pushGapBody: {
    id: 'app.sml.releases.plan.pushPlan.gapBody',
    defaultMessage: 'Untick a week to leave it out. We use the assets you have.',
  },
  addPushDrafts: {
    id: 'app.sml.releases.plan.pushPlan.add',
    defaultMessage: '{count, plural, one {Add # push draft} other {Add # push drafts}}',
  },
  closedRollout: {
    id: 'app.sml.releases.plan.closedRollout',
    defaultMessage: '{from} to {to} · {posted} posted{failed, plural, =0 {} other { · # failed}}',
  },
  show: { id: 'app.sml.releases.plan.show', defaultMessage: 'Show' },
  hide: { id: 'app.sml.releases.plan.hide', defaultMessage: 'Hide' },
  // f3 no date
  noDateTitle: { id: 'app.sml.releases.plan.setDate.title', defaultMessage: 'Set a release date to plan a rollout.' },
  noDateBody: {
    id: 'app.sml.releases.plan.setDate.body',
    defaultMessage:
      'Set the date in the Catalog. Then we put a draft on each rollout day: announce, teaser, countdown, out now and after.',
  },
  noDateAction: { id: 'app.sml.releases.plan.setDate.action', defaultMessage: 'Set the date in Catalog' },
  postNow: { id: 'app.sml.releases.plan.postNow', defaultMessage: 'Post now in Composer' },
  // Posts of this release
  postsTitle: { id: 'app.sml.releases.plan.posts.title', defaultMessage: 'Posts of this release' },
  postsSubtitle: {
    id: 'app.sml.releases.plan.posts.subtitle',
    defaultMessage: 'Every post that uses an asset of {title} or its SmartLink',
  },
  postsEmpty: { id: 'app.sml.releases.plan.posts.empty', defaultMessage: 'No post uses this release yet.' },
  postsFoot: {
    id: 'app.sml.releases.plan.posts.foot',
    defaultMessage:
      'Showing {shown} of {total}. A post made in the Composer shows here when it uses an asset of this release or its SmartLink.',
  },
  showAll: { id: 'app.sml.releases.plan.posts.showAll', defaultMessage: 'Show all' },
  colWhen: { id: 'app.sml.releases.plan.posts.when', defaultMessage: 'When' },
  colPost: { id: 'app.sml.releases.plan.posts.post', defaultMessage: 'Post' },
  colChannel: { id: 'app.sml.releases.plan.posts.channel', defaultMessage: 'Channel' },
  colState: { id: 'app.sml.releases.plan.posts.state', defaultMessage: 'State' },
  revision: { id: 'app.sml.releases.plan.posts.revision', defaultMessage: '{name} r{revision}' },
  bySmartLink: { id: 'app.sml.releases.plan.posts.bySmartLink', defaultMessage: 'Uses the SmartLink' },
  textPost: { id: 'app.sml.releases.plan.posts.textPost', defaultMessage: 'Post' },
  editInComposer: { id: 'app.sml.releases.plan.posts.edit', defaultMessage: 'Edit in Composer' },
  viewPost: { id: 'app.sml.releases.plan.posts.view', defaultMessage: 'View post' },
  tryAgain: { id: 'app.sml.releases.plan.posts.tryAgain', defaultMessage: 'Try again' },
  openCalendar: { id: 'app.sml.releases.plan.calendar.open', defaultMessage: 'Open Calendar' },
  postsLoadFailed: { id: 'app.sml.releases.plan.posts.loadFailed', defaultMessage: 'We could not load the posts.' },
  retry: { id: 'app.sml.releases.plan.retry', defaultMessage: 'Try again' },
  // Asset names (the post and the gap lines)
  assetStory: { id: 'app.sml.releases.plan.asset.story', defaultMessage: 'Story' },
  assetFeedPost: { id: 'app.sml.releases.plan.asset.feedPost', defaultMessage: 'Feed post' },
  assetAiReel: { id: 'app.sml.releases.plan.asset.aiReel', defaultMessage: 'AI reel' },
  assetArtworkInMotion: { id: 'app.sml.releases.plan.asset.artworkInMotion', defaultMessage: 'Artwork in motion' },
  assetLyricCard: { id: 'app.sml.releases.plan.asset.lyricCard', defaultMessage: 'Lyric card' },
  assetCanvas: { id: 'app.sml.releases.plan.asset.canvas', defaultMessage: 'Canvas loop' },
  assetShort: { id: 'app.sml.releases.plan.asset.short', defaultMessage: 'Short video' },
  assetFullVideo: { id: 'app.sml.releases.plan.asset.fullVideo', defaultMessage: 'Full video' },
  assetImage: { id: 'app.sml.releases.plan.asset.image', defaultMessage: 'Image' },
});
